import React from 'react'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { Divider, Typography } from '@material-ui/core'

// -------------- Styles --------------
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // Reemplaza el `width: 85%; margin: 5vh auto` que se repetía en cada pantalla
    root: {
      width: '100%',
      maxWidth: 1400,
      margin: '0 auto',
      boxSizing: 'border-box',
      padding: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(4),
      },
    },
    title: {
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
      fontSize: '1.25rem',
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.h5.fontSize,
      },
    },
    divider: {
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(4),
      },
    },
  }),
)

interface PageContainerProps {
  title: string
  children: React.ReactNode
}

export default function PageContainer({ title, children }: PageContainerProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant="h5" component="h1" className={classes.title}>
        {title}
      </Typography>
      <Divider className={classes.divider} />
      {children}
    </div>
  )
}
